var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookingdate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_5365883871561029438",
    "data-name": 5365883871561030000,
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.194,
    height: 49.194,
    viewBox: "0 0 49.194 49.194",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_829",
    "data-name": "Path 829",
    d: "M0,0H49.194V49.194H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_830",
    "data-name": "Path 830",
    d: "M2,21.5H42.995V39.945a2.05,2.05,0,0,1-2.05,2.05H4.05A2.05,2.05,0,0,1,2,39.945ZM32.746,5.1h8.2a2.05,2.05,0,0,1,2.05,2.05V17.4H2V7.149A2.05,2.05,0,0,1,4.05,5.1h8.2V1h4.1V5.1h12.3V1h4.1Z",
    transform: "translate(2.099 1.05)",
    fill: "#17b3f0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingdate);
export default __webpack_public_path__ + "static/media/bookingdate.702e67fd41f00ca4da266e14b5134dfb.svg";
export { ForwardRef as ReactComponent };